export const upper = (value) =>
  value &&
  value.replace(/^(.)|(\s|\-)(.)/g, (letter) => {
    return letter.toUpperCase();
  });

export default upper;
